const LOYALTY_STAY_UPGRADE_FALLBACK_EVENT_SUBJECT = 'loyalty_stay_upgrade'

/**
 * Builds the client event subject for a loyalty stay upgrade interaction.
 *
 * Removal handlers receive `undefined` as the upgrade type being applied, so callers pass the
 * previously applied type instead. When neither is known we emit a generic subject rather than
 * interpolating `undefined` into the subject name.
 */
function getLoyaltyStayUpgradeEventSubject(upgradeType: App.LoyaltyStayUpgradeType | undefined): string {
  return upgradeType ? `loyalty_${upgradeType}_upgrade` : LOYALTY_STAY_UPGRADE_FALLBACK_EVENT_SUBJECT
}

export default getLoyaltyStayUpgradeEventSubject
